import * as React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";
import { DonutLarge as DonutIcon } from "@mui/icons-material";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { brand, text, neutral, status } from "../../theme";

export default function LRStatusDonut({ stats = {} }) {
  const total = stats.current_month_freight || 0;
const pending = stats.current_month_pending || 0;
const completed = stats.current_month_completed || 0;

  const data = [
    { name: "Completed", value: completed, color: status.success.main },
    { name: "Pending", value: pending, color: status.warning.main },
  ].filter((d) => d.value > 0);

  const pct = (v) => (total > 0 ? Math.round((v / total) * 100) : 0);

  const displayData =
    data.length > 0
      ? data
      : [{ name: "None", value: 1, color: neutral[200] }];

  return (
    <Card
      elevation={0}
      sx={{
        border: `1px solid ${neutral[200]}`,
        borderRadius: "12px",
        p: 1.5,
        height: 250,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Stack direction="row" spacing={0.75} alignItems="center">
          <Box
            sx={{
              width: 22,
              height: 22,
              borderRadius: "5px",
              bgcolor: status.success.bg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <DonutIcon sx={{ fontSize: 14, color: status.success.main }} />
          </Box>
          <Typography
            sx={{ fontWeight: 700, fontSize: "0.82rem", color: text.primary }}
          >
            Monthly LR Status
          </Typography>
        </Stack>
      </Stack>

      {/* Donut + Legend */}
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ flex: 1, minHeight: 0 }}
      >
        {/* Donut */}
        <Box
          sx={{
            width: 130,
            height: 130,
            position: "relative",
            flexShrink: 0,
          }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={displayData}
                cx="50%"
                cy="50%"
                innerRadius={38}
                outerRadius={60}
                paddingAngle={2}
                dataKey="value"
                stroke="none"
              >
                {displayData.map((entry, i) => (
                  <Cell key={i} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "1.35rem",
                fontWeight: 800,
                color: text.primary,
                lineHeight: 1,
              }}
            >
              {total}
            </Typography>
            <Typography
              sx={{ fontSize: "0.6rem", color: text.secondary, mt: 0.25 }}
            >
              Total
            </Typography>
          </Box>
        </Box>

        {/* Legend */}
        <Stack spacing={0.75} sx={{ flex: 1, minWidth: 0 }}>
          {[
            { label: "Completed", value: completed, color: status.success.main },
            { label: "Pending", value: pending, color: status.warning.main },
          ].map((item, i) => (
            <Stack key={i} direction="row" alignItems="center" spacing={0.75}>
              <Box
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  bgcolor: item.color,
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{ fontSize: "0.72rem", color: neutral[600], flex: 1 }}
                noWrap
              >
                {item.label}
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.72rem",
                  fontWeight: 700,
                  color: text.primary,
                }}
              >
                {item.value}{" "}
                <Box component="span" sx={{ color: text.muted, fontWeight: 500 }}>
                  ({pct(item.value)}%)
                </Box>
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Card>
  );
}